#import "~/graphql/fragments/sections/default/baseEntryFields.graphql"
#import "~/graphql/fragments/assets/image.graphql"

fragment articlePreview on article_Entry {
    ... baseEntryFields
    featuredImage {
        ... image
    }
    shortDescription
}
